import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "transactions-service";
// const BASE_SERVICE_URL = "";

export default {
    getHistory(page = 1) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/transaction/merchant/history/" + page,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCSVTemplate() {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/transaction/merchant/template",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    importTransactions(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/transaction/merchant/import",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCategories() {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/transaction/merchant/categories",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    filterByDate(param, page = 1) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL +
                    "/transaction/merchant/find/customer/" +
                    page,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    filterByDateFull(param, page = 1) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL +
                    "/transaction/merchant/history/filter/" +
                    page,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    search(param, page = 1) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/transaction/merchant/search/" + page,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCustomerHistory(param, page = 1) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL +
                    "/transaction/merchant/find/customer/" +
                    page,
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCustomerUuid() {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/transaction/merchant/customers",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    export(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/transaction/merchant/export",
                param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCustomerHistoryCount(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/transaction/merchant/count/" + uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getImportsStatus(uuid) {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL +
                    "/transaction/merchant/import/status/" +
                    uuid,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getRacksCustomColumns() {
        return new Promise((resolve, reject) => {
            api.get(
                BASE_SERVICE_URL + "/transaction/merchant/custom/column/list",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCustomHistory(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL +
                    "/transaction/merchant/custom/history/" +
                    param.page,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getSummaryCount(params = {}) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + `/transaction/merchant/transaction-count`,
                params,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getHistoryV2(params = {}) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/v2/transactions/merchant/history/" + params.page,
                params.apiFields,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
};
